import { FilterNode } from '../interfaces';

/**
 * Filter tree structure for the "Filter by" dropdown.
 */

export const LICENSE_STATUS_IDS = {
    ASSIGNED: 1,
    PENDING: 2,
    UNASSIGNED: 3,
    INACTIVE: 4,
} as const;

export const FILTER_BY_TREE: FilterNode[] = [
    {
        id: 'license-status',
        label: 'License Status',
        children: [
            {
                id: 'assigned',
                label: 'Assigned',
                children: [
                    {
                        id: 'online',
                        label: 'Online',
                    },
                    {
                        id: 'offline',
                        label: 'Offline',
                        children: [
                            {
                                id: 'offline-5-days',
                                label: '5 Days',
                            },
                            {
                                id: 'offline-6-30-days',
                                label: '6 - 30 Days',
                            },
                            {
                                id: 'offline-30-plus-days',
                                label: '> 30 Days',
                            },
                        ],
                    },
                    {
                        id: 'pending',
                        label: 'Pending',
                    },
                ],
            },
            {
                id: 'unassigned',
                label: 'Unassigned',
            },
            {
                id: 'inactive',
                label: 'Inactive',
            },
            {
                id: 'recent-installs',
                label: 'Recent Installs',
            },
        ],
    },
    {
        id: 'order-by-license-status',
        label: 'Order by License S...',
        children: [
            {
                id: 'order-online',
                label: 'Online',
                isRadio: true,
            },
            {
                id: 'order-offline',
                label: 'Offline',
                isRadio: true,
            },
            {
                id: 'order-display-on',
                label: 'Display On',
                isRadio: true,
            },
            {
                id: 'order-display-off',
                label: 'Display Off',
                isRadio: true,
            },
        ],
    },
];
